import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import {
  listRequest,
  listSuccess,
  listFailure,
  upsertRequest,
  upsertSuccess,
  upsertFailure,
  deleteRequest,
  deleteSuccess,
  deleteFailure,
  detailRequest,
  detailSuccess,
  detailFailure,
} from './genericReducers'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  appointmentsListRequest: ['params', 'callback'],
  appointmentsListSuccess: ['list'],
  appointmentsListFailure: ['listError'],

  appointmentsUpsertRequest: ['params', 'callback'],
  appointmentsUpsertSuccess: [],
  appointmentsUpsertFailure: ['upsertError'],

  appointmentsSingleUpsertRequest: ['params', 'callback'],
  appointmentsSingleUpsertSuccess: [],
  appointmentsSingleUpsertFailure: ['upsertError'],

  appointmentsMultipleUpsertRequest: ['params', 'callback'],
  appointmentsMultipleUpsertSuccess: [],
  appointmentsMultipleUpsertFailure: ['upsertError'],

  appointmentsSubscriptionsListRequest: ['subscriptionsListParams'],
  appointmentsSubscriptionsListSuccess: ['subscriptionsList'],
  appointmentsSubscriptionsListFailure: ['subscriptionsListError'],

  appointmentsSubscriptionsUpsertRequest: ['params', 'callback'],
  appointmentsSubscriptionsUpsertSuccess: [],
  appointmentsSubscriptionsUpsertFailure: ['upsertError'],

  appointmentsSubscriptionsDetailRequest: ['id'],
  appointmentsSubscriptionsDetailSuccess: ['detailData'],
  appointmentsSubscriptionsDetailFailure: ['detailError'],

  appointmentsSubscriptionsDeleteRequest: ['id', 'callback'],
  appointmentsAddOnDeleteRequest: ['id', 'callback'],

  appointmentsKeyReset: ['key'],

  customFieldDeleteRequest: ['apptId', 'customFieldId', 'callback'],
  customFieldDeleteSuccess: [],
  customFieldDeleteFailure: [],

  subscriptionDeleteRequest: ['apptId', 'callback'],

  appointmentsSearchRequest: ['params', 'callback'],
  sendTestEmail: ['params', 'callback'],
  sendTestEmailSuccess: [],

  generateBookingLink: ['params', 'callback'],
  createCustomer: ['params', 'callback'],
  createManualSubscription: ['params', 'callback'],
  deleteConflict: ['id', 'callback'],

  getAllCustomerTags: ['callback'],

  createManualRecurringSubscription: ['params', 'callback'],

  deleteCustomQuestionsRequest: ['params', 'callback'],
})

export const AppointmentTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  list: [],
  listFetching: null,
  listError: null,

  detailData: {},
  detailError: null,
  detailFetching: false,

  upsertFetching: null,
  upsertError: null,
  sendingEmail: false,

  subscriptionsList: [],
  subscriptionsListFetching: null,
  subscriptionsListError: null,

  deleteFetching: null,
  deleteError: null,
})

/* ------------- Reducers ------------- */

export const reset = (state) => state.merge(INITIAL_STATE)

export const resetBasedOnKey = (state, { key }) => {
  return state.merge({
    [key]: INITIAL_STATE[key],
  })
}

export const sendTestEmail = (state) => {
  return state.merge({
    sendingEmail: true,
  })
}

export const sendTestEmailSuccess = (state) => {
  return state.merge({
    sendingEmail: false,
  })
}

export const subscriptionsListRequest = (
  state,
  { subscriptionsListParams }
) => {
  return state.merge({
    subscriptionsListParams,
    subscriptionsListFetching: true,
    subscriptionsListError: null,
  })
}

export const subscriptionsListSuccess = (state, { subscriptionsList }) => {
  return state.merge({
    subscriptionsList,
    subscriptionsListFetching: false,
  })
}

export const subscriptionsListFailure = (state, { subscriptionsListError }) => {
  return state.merge({
    subscriptionsListError,
    subscriptionsListFetching: false,
  })
}

/* ------------- Selectors ------------- */

export const AppointmentSelectors = {}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.APPOINTMENTS_LIST_REQUEST]: listRequest,
  [Types.APPOINTMENTS_LIST_SUCCESS]: listSuccess,
  [Types.APPOINTMENTS_LIST_FAILURE]: listFailure,

  [Types.APPOINTMENTS_UPSERT_REQUEST]: upsertRequest,
  [Types.APPOINTMENTS_UPSERT_SUCCESS]: upsertSuccess,
  [Types.APPOINTMENTS_UPSERT_FAILURE]: upsertFailure,

  [Types.APPOINTMENTS_SUBSCRIPTIONS_DETAIL_REQUEST]: detailRequest,
  [Types.APPOINTMENTS_SUBSCRIPTIONS_DETAIL_SUCCESS]: detailSuccess,
  [Types.APPOINTMENTS_SUBSCRIPTIONS_DETAIL_FAILURE]: detailFailure,

  [Types.APPOINTMENTS_SUBSCRIPTIONS_LIST_REQUEST]: subscriptionsListRequest,
  [Types.APPOINTMENTS_SUBSCRIPTIONS_LIST_SUCCESS]: subscriptionsListSuccess,
  [Types.APPOINTMENTS_SUBSCRIPTIONS_LIST_FAILURE]: subscriptionsListFailure,

  [Types.APPOINTMENTS_SUBSCRIPTIONS_UPSERT_REQUEST]: upsertRequest,
  [Types.APPOINTMENTS_SUBSCRIPTIONS_UPSERT_SUCCESS]: upsertSuccess,
  [Types.APPOINTMENTS_SUBSCRIPTIONS_UPSERT_FAILURE]: upsertFailure,

  [Types.APPOINTMENTS_SINGLE_UPSERT_REQUEST]: upsertRequest,
  [Types.APPOINTMENTS_SINGLE_UPSERT_SUCCESS]: upsertSuccess,
  [Types.APPOINTMENTS_SINGLE_UPSERT_FAILURE]: upsertFailure,

  [Types.APPOINTMENTS_MULTIPLE_UPSERT_REQUEST]: upsertRequest,
  [Types.APPOINTMENTS_MULTIPLE_UPSERT_SUCCESS]: upsertSuccess,
  [Types.APPOINTMENTS_MULTIPLE_UPSERT_FAILURE]: upsertFailure,

  [Types.CUSTOM_FIELD_DELETE_REQUEST]: deleteRequest,
  [Types.CUSTOM_FIELD_DELETE_SUCCESS]: deleteSuccess,
  [Types.CUSTOM_FIELD_DELETE_FAILURE]: deleteFailure,

  [Types.SEND_TEST_EMAIL]: sendTestEmail,
  [Types.SEND_TEST_EMAIL_SUCCESS]: sendTestEmailSuccess,

  [Types.APPOINTMENTS_KEY_RESET]: resetBasedOnKey,
})
